module.exports = __webpack_public_path__ + "8f98a1e9dd75f9c8549b29b39c0f740f.pdf";